<script lang="ts" setup>
	interface ScrollTopOptions {
		offset?: number|string,
		class?: string
	}
	defineProps<{ scrollTop?: ScrollTopOptions, grid?: boolean, sticky?: boolean }>()
	const appConfig = useAppConfig()
	useHead({
		titleTemplate: `%s | ${appConfig.title ? appConfig.title : import.meta.client ? location.hostname : '' }`
	})
</script>

<template>
	<header v-if="$slots.header" :class="{ 'site-grid': grid, 'sticky top-0 z-50': sticky}">
		<slot name="header"></slot>
	</header>

	<main class="flex-grow overflow-hidden" role="main">
		<slot />
	</main>

	<footer v-if="$slots.footer" :class="{ 'site-grid': grid}">
		<slot name="footer"></slot>
	</footer>
</template>

<style>
	html {
		@apply scroll-smooth;
	}
	body {
        text-rendering: optimizeSpeed;
    }
	#__nuxt {
		@apply min-h-dvh flex flex-col w-screen max-w-full
	}
</style>
